import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import Text from "@components/CustomText";
import HTML from "react-native-render-html";
// import OrderCard from "@screens/OrdersList/View/OrderCard";
import { useSelector } from "react-redux";
import { getOrderDetailById } from "@services/api";
import { saveJsonData, getJsonData } from "@utils/commonFunctions";
import t from "@constants/localization";
import OrderCard from "./OrderCard";

const PATH = "screens/SupportTree/SupportTickets/FullInfo/index";

const FullInfo = ({ ticketDetails }) => {
  const {
    cf_cx_name,
    cf_cx_phone_no,
    cf_order_id,
    description_text,
    description,
    description_new = "",
  } = ticketDetails;
  const html = ticketDetails && description_new;
  const { allOrders = [] } = useSelector((s) => s.orders);

  const [selectedOrder, setSelectedOrder] = React.useState();

  React.useEffect(() => {
    if (cf_order_id) {
      getOrderData(cf_order_id);
    }
  }, []);

  const getOrderData = async (id) => {
    try {
      const { data } = await getOrderDetailById({ orderId: id });
      if (data) {
        setSelectedOrder(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: "white",
        marginTop: 0,
        // paddingHorizontal: 25,
      }}
    >
      <View style={styles.listContainer}>
        {cf_order_id && (
          <View style={styles.listItem}>
            <Text variant="body_text_3" style={styles.listKey}>
              {t(`${PATH}/ordersId`)}
            </Text>
            <Text variant="body_text_3">{cf_order_id}</Text>
          </View>
        )}

        {cf_cx_name && (
          <View style={styles.listItem}>
            <Text variant="body_text_3" style={styles.listKey}>
              {t(`${PATH}/customersName`)}
            </Text>
            <Text variant="body_text_3">{cf_cx_name}</Text>
          </View>
        )}
        {cf_cx_phone_no && (
          <View style={styles.listItem}>
            <Text variant="body_text_3" style={styles.listKey}>
              {t(`${PATH}/customersMobileNo`)}
            </Text>
            <Text variant="body_text_3">{cf_cx_phone_no}</Text>
          </View>
        )}
      </View>
      <View style={{ marginTop: 25, paddingHorizontal: 25, paddingBottom: 20 }}>
        <Text variant="subtitle_16">{t(`${PATH}/yourTicketDescription`)}</Text>
        <View
          style={{
            backgroundColor: "rgba(235, 174, 59, 0.1)",
            padding: 16,
            marginTop: 15,
            borderRadius: 10,
          }}
        >
          <HTML
            ignoredTags={["br", "a"]}
            html={html}
            imagesMaxWidth={Dimensions.get("window").width / 2}
          />
        </View>
      </View>
      {selectedOrder && (
        <View>
          <View
            style={{
              paddingHorizontal: 25,
              paddingVertical: 16,
              backgroundColor: "#efefef",
            }}
          >
            <Text variant="subtitle_16">{t(`${PATH}/orderRelatedTicket`)}</Text>
          </View>
          <OrderCard item={selectedOrder} />
        </View>
      )}
    </View>
  );
};

export default FullInfo;

const styles = StyleSheet.create({
  listContainer: { paddingTop: 20, paddingHorizontal: 25 },
  listItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 15,
  },
  listKey: { color: "rgba(0,0,0,0.56)", width: "50%" },
  listValue: {},
});
